// extracted by mini-css-extract-plugin
export default {"button":"UiChip_button","active":"UiChip_active"};